var exports = {
  "kL": "ChannelSourcePreview.module__container___MDBJZF",
  "FS": "ChannelSourcePreview.module__textContainer___MDBJZF",
  "S7": "ChannelSourcePreview.module__nameRow___MDBJZF",
  "oo": "ChannelSourcePreview.module__nameButton___MDBJZF",
  "fh": "ChannelSourcePreview.module__nameText___MDBJZF",
  "W$": "ChannelSourcePreview.module__subtext___MDBJZF",
  "HR": "ChannelSourcePreview.module__subtextMuted___MDBJZF",
  "G4": "ChannelSourcePreview.module__subtextPrimary___MDBJZF",
  "XW": "ChannelSourcePreview.module__subtextBreadcrumb___MDBJZF",
  "$T": "ChannelSourcePreview.module__subtextChevron___MDBJZF",
  "my": "ChannelSourcePreview.module__avatar___MDBJZF",
  "YQ": "ChannelSourcePreview.module__fallbackIcon___MDBJZF",
  "bo": "ChannelSourcePreview.module__focusRingTight___MDBJZF",
};

module.exports = exports;
